import { useMutationWithContext } from '../../../../common/hooks/useMutationWithContext';
import { OpportunityInput, Reference } from 'sr-types/lib/opportunity/v1/graphql';
import { saveBookingForResource } from '../utils/resourceBookingApi';
import { client } from '../../../../supply/opportunity/opportunity';
import { failedToastMessage } from '../../../../common/utils/commonUtils';

export type ResourceOrderInputType = {
    resourceId: string;
    input: OpportunityInput;
};

type SaveBookingResponse = {
    data: {
        saveBookingForResource: {
            id: string;
            reference: Reference;
            errors?: Array<{ message: string; code: string }>;
        };
    };
};

export const useSaveBookingForResource = () => {
    const [saveBooking, { loading: bookingSaving }] = useMutationWithContext(saveBookingForResource, client);

    const saveBookingToResource = ({ resourceId, input }: ResourceOrderInputType): Promise<Reference> => {
        return saveBooking({
            variables: {
                resourceId,
                input
            }
        })
            .then((saveBookingResponse: SaveBookingResponse) => {
                if (saveBookingResponse.data.saveBookingForResource.errors) {
                    failedToastMessage('resource.booking.save.fail');
                    return Promise.reject(saveBookingResponse.data.saveBookingForResource.errors);
                } else {
                    return Promise.resolve(saveBookingResponse.data.saveBookingForResource.reference);
                }
            })
            .catch((err) => {
                failedToastMessage('resource.booking.save.fail');
                return Promise.reject(err);
            });
    };

    return { saveBookingToResource, bookingSaving };
};
